<script setup lang="ts">
import type { Primary } from '@directus/vue-split-panel';
import { computed } from 'vue';

const { showBorder = true, collapsed = false, placement } = defineProps<{
	showBorder?: boolean;
	collapsed?: boolean;
	placement?: Primary;
}>();

const handlePlacement = computed(() => {
	if (!collapsed || !placement) return 'inset-s-1/2 -translate-x-1/2';
	return placement === 'start' ? 'inset-s-0' : 'inset-e-0';
});
</script>

<template>
	<div class="relative h-full w-0">
		<div class="peer absolute inset-y-0 left-1/2 z-10 w-6 -translate-x-1/2 cursor-ew-resize" />

		<div
			class="
				absolute inset-y-0 w-px transition
				peer-hover:w-(--drag-handle-width) peer-hover:bg-primary-muted
				peer-active:w-(--drag-handle-width) peer-active:bg-primary-muted
			"
			:class="[handlePlacement, showBorder && !collapsed ? 'bg-border' : 'bg-transparent']"
		/>
	</div>
</template>
